window.profilerInfo = [];

// for profiling code
window.startProfiler =  function(){
    console.log("Profiler started.")
    window.profilerInfo = [[performance.now(),""]]
}

window.addProfilePoint = function(message){
    window.profilerInfo.push([performance.now(), message]);
}

window.endProfiler = function(){
    if (window.profilerInfo.length < 2){
        console.error("*Insufficient data to print profile info.");
    }
    var profileTime = window.profilerInfo[window.profilerInfo.length - 1][0] - window.profilerInfo[0][0];
    console.log("Total time is", profileTime, "ms");

    for(var i = 1; i < window.profilerInfo.length; i++){
        console.log(window.profilerInfo[i][1], ":", Math.round((window.profilerInfo[i][0] - window.profilerInfo[i-1][0]) / profileTime * 100), '%')
    }
}
